import {CalendarEventPriority} from "../../../shared/types/calendar-types/calendarEventPriority";
import {CalendarEventResource} from "../../../shared/types/calendar-types/calendarEventResource";
import {CalendarEventUpdateRequest} from "../../../shared/types/calendar-types/calendarEventUpdateRequest";
import {getEndDateTimeOneHourLater} from "./calendar-helper.mapper";


export function mapCalendarEventResourceToCalendarEventUpdateRequest(event: CalendarEventResource): CalendarEventUpdateRequest {
  const mappedData: CalendarEventUpdateRequest = {
    name: event.name ?? '',
    calendar_id: event.calendar_id ?? -1,
    description: event.description ?? '',
    priority: event.priority ?? CalendarEventPriority.Medium,
    creator: {notifications: event.creator.notifications ?? false},
    timing: event.timing,
    recurrence: event.recurrence,
    location: event.location ?? '',
    location_ids: event.location_ids,
    override: event.override,
    participants: event.participants,
  };

  return mappedData;
}

export function createNewCalendarEventResource(recurring: boolean, date: Date): CalendarEventResource {
  const newEvent: CalendarEventResource = {
    id: -1,
    calendar_id: -1,
    name: '',
    name_translated: null,
    description: '',
    description_translated: null,
    priority: CalendarEventPriority.Medium,
    creator: {notifications: false, user_id: null},
    timing: {
      start_at: getEndDateTimeOneHourLater(date).start.toISOString(),
      duration: 60,
      is_full_day: false,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      notify_before: 5,
      notify_time: null,
    },
    recurrence: {
      rrule: recurring ? 'FREQ=DAILY;INTERVAL=1' : '',
      deleted_occurrences: [],
      overridden_occurrences: [],
    },
    override: {
      parent_id: null,
      original_at: '',
    },
    location: '',
    location_translated: null,
    permission: {
      editable: true,
      masked: '',
    },
    etag: '',
    location_ids: [],
    participants: {
      user_ids: [],
      group_ids: [],
      external_user_emails: [],
      notify_user_ids: [],
      notify_group_ids: [],
    },
    confirmations: [],
  }
  return newEvent;
}

export function createCalendarEventUpdateRequest(): CalendarEventUpdateRequest {
  const newEvent: CalendarEventUpdateRequest = {
    name: '',
    description: '',
    location: '',
    priority: CalendarEventPriority.Medium,
    calendar_id: -1,
    creator: {notifications: false},
    timing: {
      start_at: '',
      timezone: '',
      duration: 60,
      is_full_day: false,
      notify_before: null,
      notify_time: null,
    },
    recurrence: {
      rrule: '',
      deleted_occurrences: [],
    },
    override: {
      parent_id: null,
      original_at: null,
    },
    location_ids: [],
    participants: {
      user_ids: [],
      group_ids: [],
      external_user_emails: [],
      notify_user_ids: [],
      notify_group_ids: [],
    }
  }
  return newEvent;
}

export function createCalendarEventResourceSeriesOverrideEvent(master: CalendarEventResource, start: Date): CalendarEventResource {
  const overrideEvent: CalendarEventResource = JSON.parse(JSON.stringify(master));
  overrideEvent.id = -1;
  overrideEvent.override.parent_id = master.id;
  overrideEvent.override.original_at = start.toISOString().split('T')[0];
  overrideEvent.timing.start_at = start.toISOString();
  overrideEvent.recurrence.rrule = '';
  overrideEvent.recurrence.deleted_occurrences = [];
  overrideEvent.recurrence.overridden_occurrences = [];
  overrideEvent.etag = '';
  return overrideEvent;
}